import { ItemList } from '../orm'
import { galleryList } from './gallery'

class BibNumberRecognitionList extends ItemList {

  getEntityKey() {
    return 'photographer/bib_number_recognition'
  }

  indexGallery(galleryId) {
    return async (dispatch) => {
      await dispatch(this.saveNewObject({
        action: 'index_gallery',
        gallery_id: galleryId
      }))
      dispatch(galleryList.invalidateList())
    }
  }
}

export const bibNumberRecognitionList = new BibNumberRecognitionList('bib_number_recognition__default');
